import { Box } from '@mui/material';
import { Stack } from '@mui/system';
import { useEffect, useRef, useState } from 'react';
import { scrollIntoView } from 'seamless-scroll-polyfill';
import useSWR from 'swr';

import NoteCard from './noteCard';
import NotesForm from './notesForm';

import { useMeetingContext } from '../../../contexts/meeting/meetingContext';
import meetingService, {
  getMeetingNotesURL,
} from '../../../services/meetingService';

function MeetingNotes() {
  const { meetingDetails } = useMeetingContext();
  const [idToEdit, setIDToEdit] = useState('');
  const meetingID = meetingDetails.current?.meeting_id.toString() ?? '';
  const meetingNotesURL = getMeetingNotesURL(meetingID);
  const { data: notes, mutate } = useSWR(meetingNotesURL, () => {
    return meetingService.getMeetingNotes(meetingID);
  });
  const noteCardsBottomRef = useRef<HTMLDivElement>();

  useEffect(() => {
    //wait for NoteCards to load
    setTimeout(() => {
      if (noteCardsBottomRef.current) {
        scrollIntoView(noteCardsBottomRef.current, {
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest',
        });
      }
    }, 100);
  }, []);

  return (
    <Stack height='100%'>
      <Stack flexGrow={1} gap={3} sx={{ overflowY: 'auto' }}>
        {notes?.map((note) => (
          <NoteCard
            key={note.id}
            note={note}
            onClickEdit={(id) => {
              setIDToEdit(id);
            }}
            onClickRemove={() => {
              mutate();
            }}
          />
        ))}
        <Box ref={noteCardsBottomRef} id='thisisatest' />
      </Stack>
      <Stack>
        <NotesForm
          note={notes?.find((note) => note.id === idToEdit)}
          onClickCancel={() => {
            setIDToEdit('');
          }}
          onSubmit={async () => {
            await mutate();
            if (noteCardsBottomRef.current) {
              scrollIntoView(noteCardsBottomRef.current, {
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest',
              });
            }
          }}
        />
      </Stack>
    </Stack>
  );
}

export default MeetingNotes;
